import { useEffect, useRef, type ReactNode } from 'react';

type Props = { title: string; children: ReactNode; busy: boolean; onCancel: () => void; onConfirm: () => void };
export const ConfirmAction = ({ title, children, busy, onCancel, onConfirm }: Props) => {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const previous = document.activeElement;
    const dialog = ref.current;
    if (typeof dialog?.showModal === 'function') dialog.showModal();
    else dialog?.setAttribute('open', '');
    dialog?.querySelector<HTMLButtonElement>('button')?.focus();
    return () => { if (previous instanceof HTMLElement && previous.isConnected) previous.focus(); };
  }, []);
  return <dialog ref={ref} className="confirm-dialog" role="alertdialog" aria-modal="true" aria-labelledby="confirm-action-title"
    onCancel={(event) => { event.preventDefault(); if (!busy) onCancel(); }}>
    <h2 id="confirm-action-title">{title}</h2>{children}
    <div className="dialog-actions"><button type="button" disabled={busy} onClick={onCancel}>Voltar</button>
      <button type="button" className="danger-action" disabled={busy} onClick={onConfirm}>{busy ? 'Confirmando…' : 'Confirmar revogação'}</button></div>
  </dialog>;
};
